export default "__VITE_ASSET__CIigEdGS__"